// third-party
import { FormattedMessage } from "react-intl";
import {
  IconDashboard,
  IconDeviceAnalytics,
  IconNote,
  IconBox,
  IconSettings,
  IconOutbound,
  IconFileInvoice,
  IconFileDollar,
  IconUserCircle,
  IconFileDots,
  IconBuildingCastle,
  IconLicense,
  IconAward,
  IconPaperBag,
  IconFileAnalytics
} from "@tabler/icons";
import SettingsIcon from "@mui/icons-material/Settings";
// assets
import {
  IconApps,
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconCategory
} from "@tabler/icons";

// constant
const icons = {
  IconApps,
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
};

const dashboardIcon = {
  dashboard: IconDashboard,
  device: IconDeviceAnalytics,
  notes: IconNote,
  box: IconBox,
  settings: IconSettings,
  outs: IconOutbound,
  invoice: IconFileInvoice,
  account: IconFileDollar,
  staff: IconUserCircle,
  propos: IconFileDots,
  proper: IconBuildingCastle,
  svc: IconLicense,
  lead: IconAward,
  orders: IconPaperBag,
  mybusiness: SettingsIcon,
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //



const application = {
  id: "application",
  title: <FormattedMessage id="application" />,
  icon: icons.IconApps,
  type: "group",
  children: [
    {
      id: "proposals",
      title: <FormattedMessage id="proposals" />,
      type: "item",
      icon: dashboardIcon.propos,
      url: "/dashboard/proposals",
    },

    {
      id: "projects",
      title: <FormattedMessage id="projects" />,
      type: "item",
      icon: dashboardIcon.box,
      url: "/dashboard/projects",
    },

    {
      id: "tasks",
      title: <FormattedMessage id="tasks" />,
      type: "item",
      icon: dashboardIcon.settings,
      url: "/dashboard/tasks",
    },

    {
      id: "calendar",
      title: <FormattedMessage id="calendar" />,
      type: "item",
      icon: icons.IconCalendar,
      url: "/dashboard/calendar",
    },

    {
      id: "chat",
      title: <FormattedMessage id="chat" />,
      type: "item",
      icon: icons.IconMessages,
      url: "/dashboard/chat",
    },

    {
      id: "invoices",
      title: <FormattedMessage id="invoices" />,
      type: "item",
      icon: dashboardIcon.invoice,
      url: "/dashboard/invoices",
    },

    {
      id: "expenses-group",
      title: <FormattedMessage id="expenses" />,
      type: "collapse",
      icon: dashboardIcon.outs,
      children: [
        {
          id: "expenses",
          title: <FormattedMessage id="expenses" />,
          type: "item",
          icon: dashboardIcon.outs,
          url: "/dashboard/expenses",
        },
        {
          id: "categories",
          title: <FormattedMessage id="categories" />,
          type: "item",
          icon: IconCategory,
          url: "/dashboard/categories",
        },
      ],
    },

    {
      id: "properties",
      title: <FormattedMessage id="properties" />,
      type: "item",
      icon: dashboardIcon.proper,
      url: "/dashboard/properties",
    },

    {
      id: "products",
      title: <FormattedMessage id="products" />,
      type: "item",
      icon: dashboardIcon.svc,
      url: "/dashboard/services",
    },

    {
      id: "accounts",
      title: <FormattedMessage id="accounts" />,
      type: "item",
      icon: dashboardIcon.account,
      url: "/dashboard/accounts",
    },

    {
      id: "leads",
      title: <FormattedMessage id="leads" />,
      type: "item",
      icon: dashboardIcon.lead,
      url: "/dashboard/leads",
    },

    {
      id: "orders",
      title: <FormattedMessage id="orders" />,
      type: "item",
      icon: dashboardIcon.orders,
      url: "/dashboard/orders",
    },
    
    {
      id: "reports",
      title: <FormattedMessage id="reports" />,
      type: "collapse",
      icon: IconFileAnalytics,
      children: [
        {
          id: "expenses-report",
          title: <FormattedMessage id="expenses-report" />,
          type: "item",
          icon: dashboardIcon.outs,
          url: "/dashboard/reports/expenses",
        },
        {
          id: "consolidated-report",
          title: <FormattedMessage id="consolidated-report" />,
          type: "item",
          icon: IconFileAnalytics,
          url: "/dashboard/reports/consolidated",
        },
      ],
    },
  ],
};

export default application;
